import { render, staticRenderFns } from "./PageNineElite.vue?vue&type=template&id=547a27a7&scoped=true"
import script from "./PageNineElite.vue?vue&type=script&lang=js"
export * from "./PageNineElite.vue?vue&type=script&lang=js"
import style0 from "./PageNineElite.vue?vue&type=style&index=0&id=547a27a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547a27a7",
  null
  
)

export default component.exports